<template>
	<div class="excel" style="overflow:hidden">
		<el-row :gutter="20">
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						新规/再发起
					</div>
					<div>
						<el-select v-model="formData.caseType" placeholder="请选择">
							<el-option v-for="item in selectData.caseTypeOption" :key="item"  :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>

			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						案件标题
					</div>
					<div>
						<el-input v-model="formData.title" placeholder="请输入案件标题"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						部位选择
					</div>
					<div>
						<el-select v-model="formData.parts" placeholder="请选择">
							<el-option v-for="item in selectData.partOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='9' :md='24' :sm='24' :xs='24'>
				<div class="block">
					<div class="block">
						<div class="block">
							<div class="title">
								案件发起时间
							</div>
							<div class="timebox">
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.startDatetimeFrom" type="date"
								 placeholder="选择日期">
								</el-date-picker>
								至
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.startDatetimeTo" type="date"
								 placeholder="选择日期">
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						现象分类
					</div>
					<div>
						<el-select v-model="formData.phenomenons" placeholder="请选择">
							<el-option v-for="item in selectData.phenomenonOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						对应方向
					</div>
					<div>
						<el-select v-model="formData.directions" placeholder="请选择">
							<el-option v-for="item in selectData.directionOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="block">
						<div class="title">
							案件状态
						</div>
						<div>
							<el-select v-model="formData.status" placeholder="请选择">
								<el-option v-for="item in selectData.status" :key="item" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg='9' :md='24' :sm='24' :xs='24'>
				<div class="block">
					<div class="block">
						<div class="block">
							<div class="title">
								案件结案时间
							</div>
							<div class="timebox">
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.doneDateForm" type="date"
								 placeholder="选择日期">
								</el-date-picker>
								至
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.doneDateTo" type="date"
								 placeholder="选择日期">
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						DTC有无
					</div>
					<div>
						<el-select v-model="formData.dtcint" placeholder="请选择">
							<el-option v-for="item in selectData.dtcOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						DTC
					</div>
					<div>
						<el-input v-model="formData.dtc" placeholder="请输入DTC"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						DLR名称
					</div>
					<div>
						<el-input v-model="formData.dealerName" placeholder="请输入DLR名称"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						行驶距离
					</div>
					<el-row>
						<el-col :span="10">
							<el-input type="number" v-model="formData.drivenDistance1" placeholder="请输入行驶距离"></el-input>
						</el-col>
						<el-col :span="4" style="text-align:center">至</el-col>
						<el-col :span="10">
							<el-input type="number" v-model="formData.drivenDistance2" placeholder="请输入行驶距离"></el-input>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						车型
					</div>
					<div>
						<el-input v-model="formData.vehicleType" placeholder="请输入车型名称"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						车型代码
					</div>
					<div>
						<el-input v-model="formData.vehicleCode" placeholder="请输入车型代码"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						vin
					</div>
					<div>
						<el-input v-model="formData.vin" placeholder="请输入vin"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						区域
					</div>
					<div>
						<el-select multiple v-model="formData.fieldIds2" placeholder="请选择">
							<el-option v-for="item in selectData.areaList" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						DLR情报质量
					</div>
					<div>
						<el-select v-model="formData.dlrQualityCn" placeholder="请选择">
							<el-option v-for="item in selectData.dlrQualityOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						案件重要度
					</div>
					<div>
						<el-select v-model="formData.casePriorityCN" placeholder="请选择">
							<el-option v-for="item in selectData.casePriorityOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="block">
						<div class="title">
							案件难易度
						</div>
						<div>
							<el-select v-model="formData.difficulty" placeholder="请选择">
								<el-option v-for="item in selectData.difficultyOption" :key="item" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg='9' :md='24' :sm='24' :xs='24'>
				<div class="block">
					<div class="block">
						<div class="block">
							<div class="title">
								入库时间
							</div>
							<div class="timebox">
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.doneDatetimeStart" type="date"
								 placeholder="选择日期">
								</el-date-picker>
								至
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.doneDatetimeEnd" type="date"
								 placeholder="选择日期">
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						跟进必要性
					</div>
					<div>
						<el-select v-model="formData.followup" placeholder="请选择">
							<el-option v-for="item in selectData.followupOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						跟进方向
					</div>
					<div>
						<el-input v-model="formData.followupDirection" placeholder="请输入跟进方向"></el-input>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						结案状态
					</div>
					<div>
						<el-select v-model="formData.dlrStatus" placeholder="请选择">
							<el-option v-for="item in selectData.dlrStatusOption" :key="item" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>

			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						担当
					</div>
					<div>
						<el-select default-first-option filterable allow-create v-model="formData.relayuserids" placeholder="请选择">
							<el-option v-for="item in sgleaders" :key="item[0]" :label="item[1]" :value="item[0]">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :lg='10' :md='24' :sm='24' :xs='24'>
				<div class="block">
					<div class="block">
						<div class="block">
							<div class="title">
								L/O
							</div>
							<div class="timebox">
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.offlineDateStart" type="date"
								 placeholder="选择日期">
								</el-date-picker>
								至
								<el-date-picker :clearable="false" value-format="yyyy-MM-dd" v-model="formData.offlineDateEnd" type="date"
								 placeholder="选择日期">
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg='5' :md='8' :sm='24' :xs='24'>
				<div class="block">
					<div class="title">
						维修类型
					</div>
					<div>
						<el-select default-first-option filterable allow-create v-model="formData.kubun" placeholder="请选择">
							<el-option key="一般维修" label="一般维修" value="一般维修">
							</el-option>
							<el-option key="钣喷" label="钣喷" value="钣喷">
							</el-option>
							<el-option key="初期品质" label="初期品质" value="初期品质">
							</el-option>							
						</el-select>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row class="row-bg-excel">
			<el-col :span="24" :push='9'>
				<el-button type="primary" @click="submit">检索</el-button>
				<el-button type="primary" @click="reset">重置</el-button>
				<el-button type="primary" @click="exportExcel">excel导出</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-table @selection-change="handleSelectionChange" id="out-table" height="500" ref="multipleTable" :data="tableData" style="width: 100%;">
					<el-table-column
						type="selection"
						width="55">
					</el-table-column>
					<el-table-column align="center" label="系统生成">
						<el-table-column align="center" prop="caseNo" label="No">
							<template slot-scope="scope">
								<router-link :to="'/casedetail/1/'+scope.row.id">{{scope.row.caseNo}}</router-link>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="month" label="月份"></el-table-column>
						<el-table-column align="center" prop="relayusername" label="NTL姓名"></el-table-column>
						<!-- <el-table-column align="center" prop="doneTypeCn" label="案件分类"></el-table-column> -->
					</el-table-column>

					<el-table-column align="center" label="DLR填写">
						<el-table-column align="center" prop="caseTypeCn" label="新规/再发起">

						</el-table-column>
						<el-table-column align="center" prop="startDatetime" label="案件发起时间(d)"></el-table-column>
						<el-table-column align="center" prop="dealerName" label="DLR名"></el-table-column>
						<el-table-column align="center" prop="vehicleType" label="车型"></el-table-column>
						<el-table-column align="center" prop="vehicleCode" label="车型代码"></el-table-column>
						<el-table-column align="center" prop="vin" label="VIN No."></el-table-column>
						<el-table-column align="center" prop="offlineDate" label="L/O"></el-table-column>
						<el-table-column align="center" prop="doneDatetime" label="入库时间"></el-table-column>
						<el-table-column align="center" prop="drivenDistance" label="行驶距离(km)"></el-table-column>
						<el-table-column align="center" prop="title" label="案件标题"></el-table-column>
						<el-table-column align="center" prop="partCn" label="部位选择"></el-table-column>
						<el-table-column align="center" prop="phenomenonCn" label="现象分类"></el-table-column>
						<el-table-column align="center" prop="dtcint" label="DTC有无"></el-table-column>
						<el-table-column align="center" prop="dtc" label="DTC"></el-table-column>
						<el-table-column align="center" prop="noDtcReason" label="无DTC理由"></el-table-column>
						<el-table-column align="center" prop="complain" label="CR"></el-table-column>
						<el-table-column align="center" prop="kubun" label="维修类型"></el-table-column>
						<el-table-column align="center" label="咨询内容">
							<el-table-column align="center" prop="customerConsultation" label="顾客描述"></el-table-column>
							<el-table-column align="center" prop="phenomenonConfirmation" label="现象确认"></el-table-column>
							<el-table-column align="center" prop="inspectionDiagnosis" label="检查内容"></el-table-column>
							<el-table-column align="center" prop="supportDiagnosis" label="请求支援内容"></el-table-column>
						</el-table-column>
					</el-table-column>

					<el-table-column align="center" label="NTL对应情况（TMCI填写）">
						<el-table-column align="center" prop="dlrQualityCn" label="DLR情报质量"></el-table-column>
						<el-table-column align="center" prop="backCount" label="退回次数"></el-table-column>
						<el-table-column align="center" prop="casePriorityCN" label="案件重要度"></el-table-column>
						<el-table-column align="center" prop="difficultyCn" label="案件难易度"></el-table-column>
						<el-table-column align="center" prop="firstReplyDatetime" label="初次答复时间"></el-table-column>
						<el-table-column align="center" prop="firstReplyContent" label="初次答复内容(W)"></el-table-column>
						<el-table-column align="center" prop="firstReplyElapsed" label="初次答复经过时间"></el-table-column>
						<el-table-column align="center" prop="directionsCN" label="对应方向【非必选项】(z)"></el-table-column>
						<el-table-column align="center" prop="directionDateDistance" label="对应方向确定时间"></el-table-column>
						<el-table-column align="center" prop="recognitionDate" label="现认时间(AB)"></el-table-column>
						<el-table-column align="center" prop="recognitionReason" label="未现认理由"></el-table-column>
						<el-table-column align="center" prop="rsrReleaseTime" label="RSR发行时间"></el-table-column>
						<el-table-column align="center" prop="rsrReleaseReason" label="RSR未发行理由"></el-table-column>
						<el-table-column align="center" prop="rscStartTime" label="RSC入手时间"></el-table-column>
						<el-table-column align="center" prop="finalSolution" label="最终对应方案（AG）"></el-table-column>
						<el-table-column align="center" prop="finalSolutionDate" label="最终对应方案提出时间"></el-table-column>
						<el-table-column align="center" prop="dlrStatus[0]" label="结案状态(AI)"></el-table-column>
						<el-table-column align="center" prop="doneDate" label="DLR确认结案时间"></el-table-column>
						<el-table-column align="center" prop="kubunExtra" label="案件类型"></el-table-column>
						<el-table-column align="center" prop="problemPart" label="故障零件"></el-table-column>
						<el-table-column align="center" prop="phenomenonsTmci" label="故障现象"></el-table-column>
						<el-table-column align="center" prop="problemCauses" label="故障原因"></el-table-column>
						<el-table-column align="center" prop="followup" label="跟进必要性(AK)"></el-table-column>
						<el-table-column align="center" prop="followupDirection" label="跟进方向"></el-table-column>
						<el-table-column align="center" prop="reportNo" label="技术现认、支援报告书编号"></el-table-column>
						<el-table-column align="center" prop="reportNoDates" label="报告书发行时间（AN）"></el-table-column>
						<el-table-column align="center" prop="reportDateDistance" label="报告发行LT"></el-table-column>
						<!-- <el-table-column align="center" prop="fieldId" label="区域code"></el-table-column> -->
						<el-table-column align="center" prop="area" label="区域名称"></el-table-column>
					</el-table-column>
					<el-table-column align="center" prop="deliveryDateTime" label="交车时间"></el-table-column>
					<el-table-column align="center" prop="elapsedForExcel" label="最终对应方案经过的工作时间"></el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row>
			<el-button type="primary" @click="pushFn">确认发布</el-button>
		</el-row>
		<el-row>
			<el-col :span="24" align="center">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNumber"
				 :page-sizes="[20, 30, 40, 50, 100, 200, 5000]" :pager-count="5" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				 :total="total">
				</el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import {
  getDefaultTableData,
  getOptions,
  getTableData,
  getArealist1,
  getArealist,
  getLeader,
  pushCases
} from '@/api/export.js'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
  data () {
    return {
      pageSize: null,
      total: null,
      pageNumber: 0,
      formData: {
        'startDatetimeFrom': null,
        'startDatetimeTo': null,
        'caseType': null,
        'parts': null,
        'phenomenons': null,
        'difficulty': null,
        'directions': null,
        'doneDateForm': null,
        'doneDateTo': null,
        'status': null,
        'fieldIds': null,
        'fieldIds1': [],
        'fieldIds2': [],
        dlrStatus: null,
        'relayuserids': null
      },
      selectData: {
        caseTypeOption: [null],
        phenomenonOption: [null],
        difficultyOption: [null],
        partOption: [null],
        directionOption: [null],
        status: [null],
        areaList: [null],
        leaders: [null],
        dlrQualityOption: [],
        casePriorityOption: [],
        followupOption: [],
        dtcOption: [],
        dlrStatusOption: []
      },
      tableData: [],
      sgareaList: [],
      sgleaders: [],
	  multipleSelection: []
    }
  },
  methods: {
	pushFn() {
		console.log(this.multipleSelection)
		const data = this.multipleSelection.map(item => item.id)
		pushCases(data).then(res => {
			this.$message({
				type: 'success',
				message: '推送成功'
			})
		})
	},
	handleSelectionChange(val){
		this.multipleSelection = val
	},
    // 导出表格
    exportExcel () {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
      /* get binary string as output */
      var dataInfo = wb.Sheets[wb.SheetNames[0]]
      for (var v in dataInfo) {
        if (dataInfo[v].hasOwnProperty('z') && dataInfo[v].z == 'm/d/yy') {
          dataInfo[v].v = dataInfo[v].v - 0.00050000
          dataInfo[v].z = 'yyyy/mm/dd HH:MM:SS'
        }
      }
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(new Blob([wbout], {
          type: 'application/octet-stream'
        }), 'Li-TCS输出表格.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },

    // 当页面条数改变时
    handleSizeChange (val) {
      this.pageSize = val
      let that = this
      getTableData(this.pageSize, 0, this.formData).then(res => {
        that.tableData = res.data.content
      })
    },
    // 当页码改变时
    handleCurrentChange (val) {
      let pageNumber = val - 1
      let that = this
      getTableData(this.pageSize, pageNumber, this.formData).then(res => {
        that.tableData = res.data.content
      })
    },
    // 检索数据
    submit () {
      this.pageNumber = 0
      let that = this
      let formData = this.formData
      let areaList = this.sgareaList
      let leaders = this.sgleaders
      this.formData.fieldIds = this.formData.fieldIds2.join(',')
      for (let j = 0; j < formData.fieldIds2.length; j++) {
        for (let i = 0; i < areaList.length; i++) {
          if (areaList[i]['fueldname'] == formData.fieldIds2[j]) {
            formData.fieldIds1[j] = areaList[i]['field']
          }
        }
      }

      for (let i = 0; i < leaders.length; i++) {
        if (formData.relayuserids == leaders[i][1]) {
          formData.relayuserids = leaders[i][0]
        }
      }
      getTableData(this.pageSize, that.pageNumber, formData).then(res => {
        that.tableData = res.data.content
        that.total = res.data.totalElements
        that.pageNumber = 1
        console.log(res)
      })
    },
    // 重置
    reset () {
      // this.selectData = {
      // 	caseTypeOption: [],
      // 	phenomenonOption: [],
      // 	difficultyOption: [],
      // 	partOption: [],
      // 	directionOption: [],
      // 	status: [],
      // 	areaList: [],
      // 	leaders: []
      // }
      this.formData = {
        'startDatetimeFrom': null,
        'startDatetimeTo': null,
        'caseType': null,
        'parts': null,
        'phenomenons': null,
        'difficulty': null,
        'directions': null,
        'doneDateForm': null,
        'doneDateTo': null,
        'status': null,
        'fieldIds': null,
        'fieldIds1': [],
        'fieldIds2': [],
        dlrStatus: null,
        'relayuserids': null
      }
      let that = this
      // getOptions(0).then(res => {
      // 	// 案件类型
      // 	that.selectData.caseTypeOption = that.selectData.caseTypeOption.concat(res.data.caseTypeOption)
      // 	// that.formData.caseType = res.data.caseType
      // 	// 案件难易程度
      // 	that.selectData.difficultyOption = that.selectData.difficultyOption.concat(res.data.difficultyOption)
      // 	// that.formData.difficulty = res.data.difficulty[0]
      // 	// 对应方向
      // 	that.selectData.directionOption = that.selectData.directionOption.concat(res.data.directionOption)
      // 	// 部位选择
      // 	that.selectData.partOption = that.selectData.partOption.concat(res.data.partOption)
      // 	// that.formData.parts = res.data.parts[0]
      // 	// 现象分类
      // 	that.selectData.phenomenonOption = that.selectData.phenomenonOption.concat(res.data.phenomenonOption)
      // 	// that.formData.phenomenons = res.data.phenomenons[0]
      // 	// 案件状态
      // 	that.selectData.status = that.selectData.status.concat(res.data.status)
      // })
      // // 获取地区arealist
      // getArealist1().then(res => {
      // 	let res1 = res.data.data
      // 	let arr = []
      // 	for (let i = 0; i < res1.length; i++) {
      // 		arr.push(res1[i]['fueldname'])
      // 	}
      // 	this.selectData.areaList = arr
      // 	this.$set(this.selectData,'areaList', arr)
      // })

      // // 获取担当list
      // getLeader().then(res => {
      // 	let res1 = res.data.data
      // 	let arr = []
      // 	for (let i = 0; i < res1.length; i++) {
      // 		arr.push(res1[i][1])
      // 	}
      // 	this.selectData.leaders = this.selectData.leaders.concat(arr)
      // })
    }
  },
  mounted () {
    let that = this
    getDefaultTableData(this.formData).then(res => {
      // console.log(res.data.content[0])
      that.tableData = res.data.content
      that.pageSize = res.data.size
      that.total = res.data.totalElements
    })
    getOptions(0).then(res => {
      // 案件类型
      that.selectData.caseTypeOption = that.selectData.caseTypeOption.concat(res.data.caseTypeOption)
      // that.formData.caseType = res.data.caseType
      // 案件难易程度
      that.selectData.difficultyOption = that.selectData.difficultyOption.concat(res.data.difficultyOption)
      // that.formData.difficulty = res.data.difficulty[0]
      // 对应方向
      that.selectData.directionOption = that.selectData.directionOption.concat(res.data.directionOption)
      // 部位选择
      that.selectData.partOption = that.selectData.partOption.concat(res.data.partOption)
      // that.formData.parts = res.data.parts[0]
      // 现象分类
      that.selectData.phenomenonOption = that.selectData.phenomenonOption.concat(res.data.phenomenonOption)
      // that.formData.phenomenons = res.data.phenomenons[0]
      // 案件状态
      res.data.statusOption.shift()
      that.selectData.status = that.selectData.status.concat(res.data.statusOption)
      // DLR情报质量
      that.selectData.dlrQualityOption = res.data.dlrQualityOption
      that.selectData.casePriorityOption = res.data.casePriorityOption
      that.selectData.dtcOption = res.data.dtcOption
      that.selectData.followupOption = res.data.followupOption
      that.selectData.dlrStatusOption = res.data.dlrstatusOption
    })

    // 获取地区arealist
    getArealist1().then(res => {
      let res1 = res.data.data
      let arr = []
      for (let i = 0; i < res1.length; i++) {
        arr.push(res1[i]['fueldname'])
      }
      this.selectData.areaList = this.selectData.areaList.concat(arr)
      this.sgareaList = res1
    })

    // 获取担当list
    getLeader().then(res => {
      let res1 = res.data.data
      let arr = []
      for (let i = 0; i < res1.length; i++) {
        arr.push(res1[i][1])
      }
      this.selectData.leaders = this.selectData.leaders.concat(arr)
      this.sgleaders = res1
    })
  }
}
</script>

<style scoped="scoped">
	.excel {
		text-align: left;
	}

	.block {
		line-height: 40px;
		display: flex;
		/* justify-content: space-around; */
	}

	.block .title {
		min-width: 85px;
		/* text-align: center; */
	}

	.time {
		/* max-width: 245px; */
	}

	.timebox {
		display: flex;
	}

	.row-bg-excel {
		margin-right: 100px;
	}

</style>
